/** Fixed country code shown as input prepend in catalog forms. */
export const AZ_MOBILE_COUNTRY_PREFIX = "+994";

/** Local mask without +994: hashes are replaced as the user types. */
export const AZ_MOBILE_LOCAL_MASK_SEGMENTS = [2, 3, 2, 2];
export const AZ_MOBILE_PHONE_LOCAL_MASK = "## ### ## ##";

/** @deprecated Use AZ_MOBILE_PHONE_LOCAL_MASK */
export const AZ_MOBILE_PHONE_LOCAL_PLACEHOLDER = AZ_MOBILE_PHONE_LOCAL_MASK;

/** @deprecated Use AZ_MOBILE_PHONE_LOCAL_PLACEHOLDER with prepend +994 */
export const AZ_MOBILE_PHONE_PLACEHOLDER = `${AZ_MOBILE_COUNTRY_PREFIX}${AZ_MOBILE_PHONE_LOCAL_PLACEHOLDER}`;

const AZ_MOBILE_OPERATOR_RE = /^(10|50|51|55|60|70|77|99|57|58|59)/;

export function formatAzMobileLocalMask(digits) {
  const raw = String(digits ?? "")
    .replace(/\D/g, "")
    .slice(0, 9);
  const parts = [];
  let offset = 0;
  for (const len of AZ_MOBILE_LOCAL_MASK_SEGMENTS) {
    let segment = "";
    for (let i = 0; i < len; i += 1) {
      const ch = raw[offset + i];
      segment += ch !== undefined ? ch : "#";
    }
    parts.push(segment);
    offset += len;
  }
  return parts.join(" ");
}

export function parseAzMobileLocalMask(value) {
  return String(value ?? "")
    .replace(/#/g, "")
    .replace(/\D/g, "")
    .slice(0, 9);
}

/** Caret index after the last entered digit inside the local mask. */
export function azMobileMaskCursorIndex(digitCount) {
  const count = Math.min(9, Math.max(0, digitCount));
  if (count === 0) return 0;

  let digitsSeen = 0;
  let cursor = 0;
  for (let segmentIndex = 0; segmentIndex < AZ_MOBILE_LOCAL_MASK_SEGMENTS.length; segmentIndex += 1) {
    const segmentLength = AZ_MOBILE_LOCAL_MASK_SEGMENTS[segmentIndex];
    for (let i = 0; i < segmentLength; i += 1) {
      if (digitsSeen === count) return cursor;
      cursor += 1;
      digitsSeen += 1;
    }
    if (digitsSeen === count) return cursor;
    if (segmentIndex < AZ_MOBILE_LOCAL_MASK_SEGMENTS.length - 1) {
      cursor += 1;
    }
  }
  return cursor;
}

export function extractAzMobileLocalPart(value) {
  if (value == null) return "";
  const digits = String(value).replace(/\D/g, "");
  if (!digits) return "";

  if (digits.startsWith("994")) {
    return digits.slice(3, 12);
  }
  if (digits.startsWith("0")) {
    return digits.slice(1, 10);
  }
  return digits.slice(0, 9);
}

export function buildAzMobilePhoneFromLocal(localPart) {
  const digits = String(localPart ?? "")
    .replace(/\D/g, "")
    .slice(0, 9);
  if (!digits) return "";
  return `${AZ_MOBILE_COUNTRY_PREFIX}${digits}`;
}

/**
 * Validates Azerbaijani mobile numbers:
 * +994501234567, 994501234567, 0501234567, 501234567
 */
export function isAzerbaijanMobilePhone(value) {
  if (value == null) return false;
  const raw = String(value).trim();
  if (!raw) return false;

  const digits = raw.replace(/\D/g, "");

  if (digits.length === 12 && digits.startsWith("994")) {
    const local = digits.slice(3);
    return local.length === 9 && AZ_MOBILE_OPERATOR_RE.test(local);
  }
  if (digits.length === 10 && digits.startsWith("0")) {
    return AZ_MOBILE_OPERATOR_RE.test(digits.slice(1));
  }
  if (digits.length === 9) {
    return AZ_MOBILE_OPERATOR_RE.test(digits);
  }
  return false;
}
